<template>
  <p class="error-msg">{{Object.keys(error) | adjustName}} : Inválido</p>
</template>
<script>
export default {
  name: "ErrorMsg"
};
</script>

